var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.enabled
    ? _c("ckeditor", {
        attrs: {
          editor: _vm.editor,
          config: _vm.editorConfig,
        },
        on: {
          ready: _vm.prefill,
          input: _vm.onInput,
        },
        model: {
          value: _vm.currentText,
          callback: function callback($$v) {
            _vm.currentText = $$v
          },
          expression: "currentText",
        },
      })
    : _c("textarea", {
        ref: "textarea",
        staticClass: "studip-wysiwyg wysiwyg",
        domProps: {
          value: _vm.text,
        },
        on: {
          input: function input($event) {
            return _vm.$emit("input", $event.target.value)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }